module.exports = __webpack_public_path__ + "img/face-pouting.089e3af3.svg";